// @flow

import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router';
import { Tracking } from 'web-core/src/tracking';

import Button from 'client/components/button/button';
import FormErrorNotification from 'client/components/form/formErrorNotification';
import Hero from 'client/components/account/hero';
import InputGroup from 'client/components/form/inputGroup';
import Translate from 'client/components/translate';
import { WEB_CLICK_PROVISION_CODE } from 'routes/join/constants/tracking';
import { handleRedirect } from 'routes/join/utils/index';
import type { RouterType } from 'types/react-router.flow';

const PARTNER_PREFIX = 'partner.enterprise.code';

type Props = {
  brand: string,
  provision: Function,
  redirect: string,
  router: RouterType,
  siteConfigs: Object,
  translations: Object,
  user_id: string,
  id: string,
};

type State = {
  code: string,
  error: string | null,
  isSubmitting: boolean,
};

class CodePage extends React.PureComponent<Props, State> {
  state = {
    code: '',
    error: null,
    isSubmitting: false,
  };

  clickHandler = (e: SyntheticEvent<>) => {
    const { brand, id, redirect, router, translations, user_id } = this.props;
    const { code } = this.state;
    e.preventDefault();
    this.setSubmitting(true);
    return this.props
      .provision({
        code,
        source: `enterprise-${brand}-manual`,
        id,
      })
      .then(({ data }) => {
        handleRedirect(redirect, user_id, data, router);
      })
      .catch(({ response }) => {
        const errorMessage =
          response.status === 422
            ? _.get(response, 'data.message')
            : _.get(translations, 'common.error.generic');

        this.setState({
          error: errorMessage,
          isSubmitting: false,
        });
      })
      .finally(() => {
        Tracking.track(WEB_CLICK_PROVISION_CODE, { type: 'submit code', client: brand });
      });
  };

  handleChange = (e: SyntheticEvent<>) => {
    const { id, value } = e.currentTarget;
    this.setState({
      [id]: value,
    });
  };

  setSubmitting = (isSubmitting: boolean) => {
    this.setState({ isSubmitting });
  };

  render() {
    const { brand, siteConfigs } = this.props;
    const { code, error } = this.state;
    return (
      <div className="account-page text-center">
        <Hero brandName={brand} siteConfigs={siteConfigs} />
        {this.state.error && (
          <FormErrorNotification
            translateKey="partner.enterprise.error"
            translateUsing={{ errorMessage: error }} />
        )}
        <div className="center-col-small">
          <div className="margin-2">
            <h4 className="semi-bold pad-bottom">
              <Translate path={`${PARTNER_PREFIX}.header`} />
            </h4>
            <p>
              <Translate path={`${PARTNER_PREFIX}.subheader`} />
            </p>
          </div>
          <InputGroup
            id="code"
            label={{
              path: `${PARTNER_PREFIX}.label`,
            }}
            type="text"
            value={code}
            onChange={this.handleChange} />
          <Button
            className="cta-button margin-top"
            clickHandler={this.clickHandler}
            isDisabled={this.state.isSubmitting}>
            <Translate path="common.submit" />
          </Button>
          <p className="pad-y">
            <Translate path={`${PARTNER_PREFIX}.help`} />
            <Link to="/contact">
              <Translate path={`${PARTNER_PREFIX}.helpCta`} />
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default CodePage;
